import Vue from 'vue'

/**
 * 设置基础URL
 */
let base = '/apiv1/role'

/**
 * 查询用户角色列表
 */
export const queryRoleTree = (params) => {
  return Vue.fetch.post(`${base}/queryRoleTree`, params)
}

export const addRoleGroup = (params) => {
  return Vue.fetch.post(`${base}/addRoleGroup`, params)
}
/**
 * 新增角色
 */
export const add = (params) => {
  return Vue.fetch.post(`${base}/add`, params)
}
/**
 * 修改角色
 */
export const update = (params) => {
  return Vue.fetch.post(`${base}/update`, params)
}

export const removeRole = (params) => {
  return Vue.fetch.post(`${base}/remove`, params)
}

export const removeRoleGroup = (params) => {
  return Vue.fetch.post(`${base}/removeRoleGroup`, params)
}

/**
 * 角色添加用户
 */
export const addUsersToRole = (params) => {
  return Vue.fetch.post(`${base}/addUsersToRole`, params)
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/role.js